<template>
  <nf-confirm
    class="switch-company"
    :show.sync="show"
    width="554px"
    title="切换企业"
    :is-cancel-btn="false"
    save-btn-text="切换企业"
    :handle-save-btn-click="handleSaveBtnClick"
  >
    <div slot="content">
      <ul>
        <li
          v-for="(item, index) in companyList"
          :key="index"
          @click="handleSwicthClick(item.subDomain)"
        >
          <el-radio v-model="radio" :label="item.subDomain">
            {{ item.name }}
          </el-radio>
        </li>
      </ul>
    </div>
  </nf-confirm>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      inputShow: false,
      radio: '',
      toUrl: '',
    };
  },
  computed: {
    companyList() {
      return this.$store.state.companyList;
    },
    isCompanyModal() {
      return this.$store.state.isCompanyModal;
    },
  },
  watch: {
    isCompanyModal(newValue) {
      if (newValue) {
        this.show = true;
      }
    },
    show(newValue) {
      if (newValue) {
        this.$store.commit('updateCompanyModal', false);
      }
    },
  },
  async created() {
    this.radio = location.host.split('.')[0];
  },
  methods: {
    handleSwicthClick(subDomain) {
      let sub = location.host.split('.')[0];
      let re = new RegExp(sub);
      if (subDomain === sub) {
        this.toUrl = '';
      } else {
        this.toUrl = origin.replace(re, subDomain);
      }
    },
    async handleSaveBtnClick() {
      if (!this.toUrl) {
        this.show = false;
      } else {
        window.location.href = this.toUrl;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.switch-company .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: rgba(32, 44, 85, 1);
  line-height: 25px;
  position: relative;
}
.inputBtn {
  position: absolute;
  top: 20px;
  width: 300px;
  left: 120px;
  z-index: 78;
}
.el-fordanzhidianji {
  position: absolute;
  top: 20px;
  left: 120px;
  font-size: 24px;
  z-index: 78;
  cursor: pointer;
}
.switch-company .el-dialog__title::after {
  content: '点击需要切换的企业';
  margin-left: 15px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(130, 137, 164, 1);
  line-height: 20px;
}
.switch-company ul {
  margin-left: 35px;
}
.el-radio__input.is-checked + .el-radio__label {
  color: hsla(221, 71%, 44%, 1);
}
.switch-company .el-radio__label {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: rgba(32, 44, 85, 1);
}
.switch-company li {
  display: flex;
  height: 22px;
  margin-bottom: 25px;
}
.el-dialog__title {
  color: #181818 !important;
  font-weight: 650 !important;
}
</style>
